import FileTag from "components/FileUpload/filetag";
import moment from "moment";
import React from "react";
import { formatWrittenDateTimeUtc, newLineToBr } from "utilities";

interface Props {
  upload: server.dto.AdvancingUpload
  onDeleteFile: (file: server.dto.AdvancingFile) => void
}

export const AdvancingUploadCard = ({ upload, onDeleteFile }: Props) => {
  const createdUtc = moment.utc(upload.createdUtc);
  const count = upload.files.length;
  const uploadedText = count === 1
    ? RESX.AdvancingTimeline.uploadedAFile
    : RESX.AdvancingTimeline.uploadedFiles.replace("{0}", count.toString());

  return <div className="card-surface-standalone radius padding flex-column gap-large">
    {upload.message && <div className="advancing-message-body">{newLineToBr(upload.message)}</div>}
    <div className="flex flex-wrap gap-small">
      {upload.files.map(file => <FileTag
        key={file.clientFileId}
        fullName={file.fileName}
        downloadUrl={file.downloadLink}
        onClear={() => onDeleteFile(file)}
      />)}
    </div>
    <div className="text-sublabel" title={formatWrittenDateTimeUtc(createdUtc)}>{upload.actorName} {uploadedText} {createdUtc.fromNow()}</div>
  </div>;
};
